import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { FormsUtilsService } from '../../../../../../../core';
import { ButtonLoader } from '../../../../../../../core/utils';
import { CampanhaSelectFormComponent } from '../../../../../../campanhas/campanhas/components/select-form';
import { isStatusEmAndamento } from '../../../../../../campanhas/campanhas/status';
import { isClienteCadastroProspect } from '../../../../../../pessoa/cliente/cadastro/cliente-cadastro';
import { Cliente } from '../../../../../../pessoa/cliente/cliente';
import { Usuario } from '../../../../../../usuario';
import { Lead } from '../../../../../lead/lead';

@Component({
    selector: 'sgt-negocio-form-insert-step-negocio',
    templateUrl: './negocio-form-insert-step-negocio.component.html',
    styleUrls: ['./negocio-form-insert-step-negocio.component.less']
})
export class NegocioFormInsertStepNegocioComponent implements OnChanges  {
    @Input() isFaseQualificacao: boolean;
    @Input() isFaseOportunidade: boolean;

    @Input() lead: Lead;
    @Input() cliente: Cliente;

    @Input() idUsuarioResponsavel: number;
    @Output() idUsuarioResponsavelChange = new EventEmitter<number>();

    @Input() usuarioResponsavel: Usuario;
    @Output() usuarioResponsavelChange = new EventEmitter<Usuario>();

    @Input() prioridade: number;
    @Output() prioridadeChange = new EventEmitter<number>();

    @Input() dataPrevisaoFechamento: Date;
    @Output() dataPrevisaoFechamentoChange = new EventEmitter<Date>();

    @Input() valor: number;
    @Output() valorChange = new EventEmitter<number>();

    possuiCampanha: boolean;
    @Input() idCampanha: number;
    @Output() idCampanhaChange = new EventEmitter<number>();

    @Output() previus = new EventEmitter<void>();
    @Output() next = new EventEmitter<void>();

    @Input() isCreating: boolean;
    @Input() btnCreateText = 'Criar Negócio';
    @Input() btnCreatingText = 'Criando Negócio';
    btnCreate: ButtonLoader;


    @ViewChild('form') form: NgForm;
    @ViewChild('campanhaSelectForm') campanhaSelectForm: CampanhaSelectFormComponent;

    constructor(private formsUtilsService: FormsUtilsService) { }

    ngOnChanges(changes: SimpleChanges): void {
        for (const propName in changes) {
            if (propName === 'isCreating') {
                if (changes[propName].isFirstChange()) {
                    return;
                }

                if (!this.btnCreate) {
                    this.btnCreate = new ButtonLoader('#negocioBtnCreate');
                }

                if (this.isCreating) {
                    this.btnCreate.loading(this.btnCreatingText);
                } else {
                    this.btnCreate.reset();
                }
            } else if (propName === 'lead') {
                this.setCampanhaLead();
            } else if (propName === 'cliente') {
                this.setCampanhaCliente();
            }
        }
    }

    onChangeUsuarioResponsavel(usuario: Usuario) {
        if (usuario) {
            this.idUsuarioResponsavel = usuario.id;
            this.usuarioResponsavel = usuario;
        } else {
            this.idUsuarioResponsavel = null;
            this.usuarioResponsavel = null;
        }

        this.idUsuarioResponsavelChange.emit(this.idUsuarioResponsavel);
        this.usuarioResponsavelChange.emit(this.usuarioResponsavel);
    }

    onChangePrioridade(prioridade: number) {
        this.prioridade = prioridade;
        this.prioridadeChange.emit(this.prioridade);
    }

    onChangeDataPrevisaoFechamento(data: Date) {
        this.dataPrevisaoFechamento = data;
        this.dataPrevisaoFechamentoChange.emit(this.dataPrevisaoFechamento);
    }

    onChangeValor(valor: number) {
        this.valor = valor;
        this.valorChange.emit(this.valor);
    }

    /** Seta a campanha do lead no negócio */
    private setCampanhaLead() {
        if (!this.lead || !this.isFaseQualificacao) {
            return;
        }

        // Se a campanha de origem do lead estiver em andamento
        if (this.lead.campanhaOrigem && isStatusEmAndamento(this.lead.campanhaOrigem.status)) {
            this.possuiCampanha = true;
            this.onChangeCampanha(this.lead.campanhaOrigem.id);
        }
    }

    /** Seta a campanha do cliente no negócio */
    private setCampanhaCliente() {
        if (!this.cliente || !this.isFaseOportunidade) {
            return;
        }

        // Se for um prospect e sua campanha de origem estiver em andamento
        if (isClienteCadastroProspect(this.cliente.cadastro) &&  this.cliente.campanhaOrigem && isStatusEmAndamento(this.cliente.campanhaOrigem.status)) {
            this.possuiCampanha = true;
            this.onChangeCampanha(this.cliente.campanhaOrigem.id);
        }
    }

    onChangeCampanha(idCampanha: number) {
        this.idCampanha = idCampanha;
        this.idCampanhaChange.emit(this.idCampanha);
    }

    private isValid(): boolean {
        this.formsUtilsService.makeAllFieldsDirty(this.form);

        // Campanha
        if (!this.campanhaSelectForm?.isValid()) {
            return false;
        }

        // Form válido
        return this.form?.valid;
    }

    nextClick() {
        if (!this.isValid()) {
            return;
        }

        // Campanha
        this.campanhaSelectForm?.resolve();

        this.next.emit();
    }
}
